export default "__VITE_ASSET__8rrdNzfe__"